// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__JFa8I","notFoundError":"NotFound_notFoundError__RdMWd"};